export const FETCH_HL7_QUEUE = "[ADMIN] FETCH_HL7_QUEUE";
export const FETCH_HL7_QUEUE_START = "[ADMIN] FETCH_HL7_QUEUE_START";
export const FETCH_HL7_QUEUE_SUCCESS = "[ADMIN] FETCH_HL7_QUEUE_SUCCESS";
export const FETCH_HL7_QUEUE_ERROR = "[ADMIN] FETCH_HL7_QUEUE_ERROR";

export const SHOW_ACKNOWLEDGEMENT_MODAL = "[ADMIN] SHOW_ACKNOWLEDGEMENT_MODAL";
export const CLOSE_ACKNOWLEDGEMENT_MODAL = "[ADMIN] CLOSE_ACKNOWLEDGEMENT_MODAL";

export const fetchAllHL7Queue = (payload) => {
    return {
        type: FETCH_HL7_QUEUE,
        payload
    };
};

export const showAcknowledgementModal = (selectedRow) => {
    return {
        type: SHOW_ACKNOWLEDGEMENT_MODAL,
        selectedRow
    };
};

export const closeAcknowledgementModal = () => {
    return {
        type: CLOSE_ACKNOWLEDGEMENT_MODAL
    };
};